import { render, staticRenderFns } from "./OrSeparator.vue?vue&type=template&id=9c7a9f64"
import script from "./OrSeparator.vue?vue&type=script&lang=js"
export * from "./OrSeparator.vue?vue&type=script&lang=js"
import style0 from "./OrSeparator.vue?vue&type=style&index=0&id=9c7a9f64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports